import { render } from "./noConfirm.vue?vue&type=template&id=70736251&scoped=true"
import script from "./noConfirm.vue?vue&type=script&lang=js"
export * from "./noConfirm.vue?vue&type=script&lang=js"

import "./noConfirm.vue?vue&type=style&index=0&id=70736251&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70736251"]])

export default __exports__